import { trackECommerceEvent } from '~/tools/analytics/googleAnalytics';
import userStore from '~/redux/user/store';

export function pushViewPlansEvent(plans){
  const ga = window.ga;
  const dataLayer = window.dataLayer || { push: _ => {} }
    ga('set', 'currencyCode', plans[0].planDetails[0].recurringPaymentCurrencyCode);
    plans.forEach((plan) => {
      trackECommerceEvent('ec:addImpression',{
        id: plan.id,
        name: plan.name,
        price: plan.planDetails[0].recurringPaymentAmount
      })
    });
    ga('send', 'event', 'e-commerce', 'impression'); 
    dataLayer.push({
      'event': 'view_plans'
    });
}

export function pushSelectPlanEvent(plan){
  const ga = window.ga;
const dataLayer = window.dataLayer || { push: _ => {} }
    ga('ec:setAction', 'checkout', {'step': 1});
    ga('set', 'currencyCode', plan.planDetails[0].recurringPaymentCurrencyCode);
    trackECommerceEvent('ec:addProduct',{
      id: plan.id,
      name: plan.name,
      price: plan.planDetails[0].recurringPaymentAmount,
      quantity: 1
    });
    ga('send', 'event', 'e-commerce', 'checkout', '1');
    dataLayer.push({
      'event': 'select_plan',
      'plan_currency_code': plan.planDetails[0].recurringPaymentCurrencyCode,
      'plan_uuid': plan.id,
      'plan_name': plan.name,
      'plan_price': plan.planDetails[0].recurringPaymentAmount
    });
}

export function pushFinishRegistrationEvent(){
const dataLayer = window.dataLayer || { push: _ => {} }
    dataLayer.push({
      'event': 'finish_registration'
    });
}

export async function pushFinishSubscriptionEvent(plan){
  const ga = window.ga;
const dataLayer = window.dataLayer || { push: _ => {} }
    const userId = userStore.getState().user.userId;
    await ga('ec:setAction', 'checkout', {'step': 2});
    await trackECommerceEvent('ec:addProduct',{
      id: plan.id,
      name: plan.name,
      price: plan.planDetails[0].recurringPaymentAmount,
      quantity: 1
    });
    await ga('send', 'event', 'e-commerce', 'checkout', '2')
    await ga('ec:setAction', 'purchase',{
      revenue: plan.planDetails[0].recurringPaymentAmount,
      id: `${userId} - ${Date.now()}`
    });
    await trackECommerceEvent('ec:addProduct',{
      id: plan.id,
      name: plan.name,
      price: plan.planDetails[0].recurringPaymentAmount,
      quantity: 1
    });
    await ga('set', 'currencyCode', plan.planDetails[0].recurringPaymentCurrencyCode);
    await ga('send', 'event', 'e-commerce', 'purchase');
    await dataLayer.push({
      'event': 'finish_subscription',
      'plan_currency_code': plan.planDetails[0].recurringPaymentCurrencyCode,
      'plan_uuid': plan.id,
      'plan_name': plan.name,
      'plan_price': plan.planDetails[0].recurringPaymentAmount,
      'transaction_id': `${userId} - ${Date.now()}`
    });
}
